<template>
  <v-container>
    <v-flex xs12 class="background">
      <v-toolbar height="56" color="primary">
        <v-toolbar-title id="idCabecalhoJanela" class="subheading white--text">
          Coberturas do Endosso
        </v-toolbar-title>
      </v-toolbar>
      <v-layout pa-5>
        <v-flex row wrap>
          TIPO DE ENDOSSO
          <p>{{ getTipoEndosso(idTipoEndosso) }}</p>
        </v-flex>
        <v-flex row wrap> CÓD. COTAÇÃO ENDOSSO </v-flex>
        <v-flex> N. PROPOSTA / ENDOSSO </v-flex>
        <v-flex>DIAS DE VIGÊNCIA ENDOSSO </v-flex>
        <v-flex>RAZÃO SOCIAL </v-flex>
        <v-flex> CNPJ </v-flex>
        <v-flex> QTD. ÍTENS INCLUSÃO </v-flex>
        <v-flex> VLR.ENDOSSO </v-flex>
        <v-flex>
          <br />
        </v-flex>
        <v-spacer></v-spacer>
        <v-spacer></v-spacer>
        <v-flex v-if="resultados.totalPremio"
          >PRÊMIO TOTAL
          <p></p>
        </v-flex>
      </v-layout>
    </v-flex>
    <v-container pa-5 class="background data-table">
      <v-form>
        <v-card elevation="0">
          <v-card-title>
            <v-flex xs12 sm11 md6 lg4>
              <transition name="fade">
                <v-flex xs1 v-if="!filtro.pesquisa.opened">
                  <v-btn
                    v-if="!filtro.pesquisa.opened"
                    @click="filtroFunctions().abrirFiltroPesquisa()"
                    color="primary"
                    round
                    outline
                    icon
                    ><v-icon>search</v-icon></v-btn
                  >
                </v-flex>
                <v-flex v-else>
                  <v-text-field
                    v-model="filtro.pesquisa.conteudo"
                    prepend-icon="search"
                    @click:prepend="filtroFunctions().fecharFiltroPesquisa()"
                    @blur="filtroFunctions().fecharFiltroPesquisa()"
                    label="Busca"
                    autofocus
                    clearable
                  ></v-text-field>
                </v-flex>
              </transition>
            </v-flex>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>


          </v-card-title>
          <v-data-table
            :headers="headers"
            :items="errosFiltrados"
            :pagination.sync="pagination"
            :rows-per-page-items="[10, 25, 50, 100, 150, 200, 300, 400, 500]"
            rows-per-page-text="Itens por página"
            item-key="item"
            class="elevation-0"
          >
            <template v-slot:items="props">
              <td
              :class="{
                'faixa-modificado': props.item.isModificado || props.item.isOriginalModificado,
              }">
                <v-checkbox
                  class="checkbox"
                  color="primary"
                  primary
                  hide-details
                  :value="
                    props.item && selected && props.item.item === selected.item
                  "
                  @change="(value) => (selected = value ? props.item : null)"
                  :disabled="(selected && selected.item !== props.item.item) || idPropostaStatus == 7"
                ></v-checkbox>
              </td>
              <td
                v-for="([texto, atributos], index) in colunas(props.item)"
                :key="index"
                v-bind="atributos"
                :class="[
                  'themeGrey--text click',
                  ...(atributos.class || []),
                  {
                    'linha-original-modificada':
                      props.item.isOriginalModificado &&
                      props.item.camposModificados &&
                      props.item.camposModificados.includes(atributos.value),
                  },
                  {
                    'coluna-modificada':
                      props.item.isModificado &&
                      props.item.camposModificados &&
                      props.item.camposModificados.includes(atributos.value),
                  },
                ]"
              >
                {{ texto }}
              </td>
            </template>
            <template v-slot:pageText="props">
              {{ props.pageStart }} - {{ props.pageStop }} de
              {{ props.itemsLength }}
            </template>
            <template v-slot:no-results>
              <v-alert :value="true" color="error" icon="warning">
                Sua pesquisa não foi encontrada.
              </v-alert>
            </template>
          </v-data-table>
          <v-snackbar v-model="snack" :timeout="3500" :color="snackColor">
            {{ snackText }}
            <v-btn flat @click="snack = false">Fechar</v-btn>
          </v-snackbar>
        </v-card>
      </v-form>
    </v-container>
    <v-layout pt-5>
      <v-flex>
        <v-btn color="primary" @click="voltar" flat> Voltar </v-btn>
      </v-flex>
      <v-spacer></v-spacer>
      <v-spacer></v-spacer>
      <v-spacer></v-spacer>
      <v-spacer></v-spacer>
      <v-spacer></v-spacer>
      <v-flex>
        <v-btn
          v-if="botaoVerCalculo"
          color="secondary"
          elevation="2"
          max-width="121px"
          width="100"
          right
          @click="dialogCalculo = true"
        >
          Ver Calculo
        </v-btn>
        <v-btn
          v-else
          color="secondary"
          elevation="2"
          max-width="121px"
          width="100"
          right
          @click="solicitarCalculo"
          >Calcular</v-btn
        >
      </v-flex>
    </v-layout>

    <template>
      <v-layout row justify-center>
        <v-dialog persistent v-model="dialogCalculo" max-width="1200px">
          <ModalDeCalculo
            v-if="dialogCalculo"
            :dialog="dialogCalculo"
            :resultados="camposDisabled ? totaisCalculados() : resultados"
            :statusProposta="camposDisabled"
            :camposInfoGerais="camposInfoGerais"
            @fechar="dialogCalculo = false"
            @ativarLoader = " loaderPagina = true "
            @desativarLoader = " loaderPagina = false "
          />
        </v-dialog>
      </v-layout>
    </template>

    <template>
      <v-layout row justify-center>
        <v-dialog v-model="dialog" hide-overlay fullscreen>
          <AdicionarItemEndossoModal
            v-if="dialog"
            @add="adicionarModificacao($event), (dialog = false)"
            :item="proximoIndice"
            :dialog="dialog"
            @fechar="dialog = false"
            :campos="campos"
            :alterarValores="true"
            :placa="placaSelecionada"
            :modificacoes="modificacoesItem"
            :diferencaObjetos="true"
          />
        </v-dialog>
      </v-layout>
    </template>
    <template>
      <v-dialog
        persistent
        v-model="loaderPagina"
        width="500"
        content-class="elevation-0"
      >
        <v-card >
          <v-container style="background-color: #FFF;height: 100px;">
            <v-layout row wrap
              class="fill-height"
              align-content="center"
              justify="center"
            >
              <v-flex md12
                class="text-subtitle-1 text-center"
              >
                <p style="font-weight: bold; margin-bottom: 0; text-align: center">Processando, aguarde...</p>
              </v-flex>
              <v-flex md12>
                <v-progress-linear
                  :indeterminate="true"
                  color="primary"
                  height="6"
                  value="15"
                ></v-progress-linear>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card>
      </v-dialog>
    </template>
  </v-container>
</template>

<script>
import axios from "axios";
import { mapState } from "vuex";
import usuarioHelper from "@/helpers/usuario-logado.js";
import ModalDeCalculo from "./ModalDeCalculo.vue";
import AdicionarItemEndossoModal from "./AdicionarItemEndossoModal";
import statusEndossoEnum from "@/helpers/status-endosso-enum.js";
const CAMPOS_COMPARAVEIS = [
  'item',
  'placa',
  'tipoCobertura',
  'tipoDeContratacao',
  'percAjusteVmrOuVd',
  'tipoDeFranquia',
  'valorFipe',
  'vdContratado',
  'danosMateriais',
  'danosCorporais',
  'danosMoraisEEsteticos',
  'vlrFranquiaDanosMateriais',
  'garantiaUnica',
  'vlrGarantiaUnica',
  'vlrFranquiaGarantiaUnica',
  'appMorte',
  'appInvalidez',
  'despesasMedicasHospitalaresEOdontologicas',
  'coberturaAdicionalDespesasExtras',
  'despesasExtras',
  'caminhaoBasculado',
  'diasGarantZeroKm',
  'garantiaCompreensivaParaTumultos',
  'extCobAmericaDoSul',
  'rcfExtCobAmericaDoSul',
  'vlrRcfExtCobAmericaDoSul',
  'danosMateriaisADirigentesSociosEmpregadosEPrepostos',
  'vlrDmDirigenteSociosEmpregadosPrepostos',
  'danosCorporaisADirigentesSociosEmpregadosEPrepostos',
  'vlrDanosCorporaisADirigentesSociosEmpregadosEPrepostos',
  'guDmDcADirigentesSociosEmpregadosEPrepostos',
  'vlrGuDmDcADirigentesSociosEmpregadosEPrepostos',
  'danosMateriaisCorporaisATerceirosCausadoPorReboqueSemirreboqueDesatrelado',
  'extensaoDeCoberturaRcfAVeiculosRebocados',
  'vlrExtensaoDeCoberturaRcfAVeiculosRebocados',
  'coberturaAdicionalCarroceria',
  'descrCarroceria',
  'vlrCarroceria',
  'coberturaAdicionalEquipamentos',
  'descEquipamentos',
  'vlrEquipamentos',
  'coberturaAdicionalAcessorios',
  'descAcessorios',
  'vlrAcessorios',
  'vlrBlindagem',
  'vlrKitGas',
  'kmAssistencia',
  'carroReserva',
  'coberturaVidros',
  'tipoDeProposta',
  'classeBonus',
  'numeroApoliceAnterior',
  'numeroItemAnterior',
  'renovacaoComSinistro',
  'ciaRenovacao',
  'codRenovacao',
  'despesasSalvamentoContencaoSinistro',
  'vlrDespesasSalvamentoContencaoSinistro'
];

const REGRAS_EQUIVALENCIA = {
  coberturaAdicionalAcessorios: {
    equivalentes: [
      [null, "false"]
    ]
  },
  coberturaAdicionalEquipamentos: {
    equivalentes: [
      [null, "false"]
    ]
  },
  coberturaAdicionalCarroceria: {
    equivalentes: [
      [null, "false"]
    ]
  },
  vlrEquipamentos: {
    equivalentes: [
      [null, "0"]
    ]
  },
  vlrAcessorios: {
    equivalentes: [
      [null, "0"]
    ]
  },
  vlrCarroceria: {
    equivalentes: [
      [null, "0"]
    ]
  },
};

const MAPA_LISTAS_OBJETO = {
  tipoCobertura: 'tipoCoberturaList',
  tipoDeContratacao: 'tipoDeContratacaoList',
  tipoDeFranquia: 'tipoDeFranquiaList',
  tipoDeProposta: 'tipoDePropostaList',
  ciaRenovacao: 'ciaRenovacaoList',
  kmAssistencia: 'kmAssistenciaList',
  carroReserva: 'carroReservaList',
  descrCarroceria: 'descrCarroceriaList',
  descrEquipamentos: 'descrEquipamentosList',
  descrAcessorios: 'descrAcessoriosList',
  coberturaVidros: 'coberturaVidrosList',
  diasGarantZeroKm: 'diasGarantZeroKmList',
  ufPernoite: 'ufPernoiteList',
};

export default {
  name: "CoberturaEndossoSubstituicao",
  components: {
    ModalDeCalculo,
    AdicionarItemEndossoModal,
  },
  data() {
    return {
      idStatusEndosso: null,
      loaderPagina: false,
      idPropostaStatus: null,
      idApolice: null,
      idTipoEndosso: null,
      dialog: false,
      menu: false,
      filtrarErros: false,
      simOuNao: [
        {
          id: true,
          titulo: "Sim",
        },
        {
          id: false,
          titulo: "Não",
        },
      ],
      headers: [
        { text: "", align: "center", value: "", notSortable: false, class: "pa-0" },
        { text: "ITEM", align: "center", value: "item", class: "item-primary" },
        {
          text: "PLACA",
          align: "center",
          value: "placa",
        },
        { text: "TIPO DE COBERTURA", align: "center", value: "tipoCobertura" },
        { text: "TIPO DE CONTRATAÇÃO", align: "center", value: "tipoDeContratacao" },
        { text: "% AJUSTE VMR/VD", align: "center", value: "percAjusteVmrOuVd" },
        { text: "TIPO DE FRANQUIA", align: "center", value: "tipoDeFranquia" },
        { text: "VLR. FIPE", align: "center", value: "valorFipe" },
        { text: "VD CONTRATADO", align: "center", value: "vdContratado" },
        { text: "DANOS MATERIAIS", align: "center", value: "danosMateriais" },
        { text: "DANOS CORPORAIS", align: "center", value: "danosCorporais" },
        { text: "DANOS MORAIS E ESTÉTICOS", align: "center", value: "danosMoraisEEsteticos" },
        { text: "VLR. FRANQUIA DM", align: "center", value: "vlrFranquiaDanosMateriais" },
        { text: "GARANTIA ÚNICA", align: "center", value: "garantiaUnica" },
        { text: "VLR. GARANTIA ÚNICA", align: "center", value: "vlrGarantiaUnica" },
        { text: "VLR. FRANQUIA GU", align: "center", value: "vlrFranquiaGarantiaUnica" },
        { text: "APP MORTE", align: "center", value: "appMorte" },
        { text: "APP INVALIDEZ", align: "center", value: "appInvalidez" },
        {
          text: "DMHO",
          align: "center",
          value: "despesasMedicasHospitalaresEOdontologicas",
          tool: "DESP. MÉDICAS, HOSPITALARES E ODONTOLÓGICAS",
        },
        {
          text: "AD. DESP. EXTRA",
          align: "center",
          value: "coberturaAdicionalDespesasExtras",
          tool: "COBERTURA ADICIONAL: DESPESAS EXTRAS",
        },
        { text: "DESPESAS EXTRAS", align: "center", value: "despesasExtras" },
        { text: "CAMINHÃO BASCULADO", align: "center", value: "caminhaoBasculado" },
        { text: "DIAS DE GARANTIA ZERO KM", align: "center", value: "diasGarantZeroKm" },
        {
          text: "COMPREENSIVA: TUMULTOS",
          align: "center",
          value: "garantiaCompreensivaParaTumultos",
          tool: "GARANTIA COMPREENSIVA PARA TUMULTOS",
        },
        { text: "EXT. COB. AMÉRICA DO SUL", align: "center", value: "extCobAmericaDoSul" },
        { text: "RCF - EXT. COB. AMÉRICA DO SUL",
          align: "center",
          value: "rcfExtCobAmericaDoSul",
          tool: "RCF - EXT. DE PERÍMETRO PARA AMÉRICA DO SUL"
        },
        { text: "VLR. RCF - EXT. COB. AMÉRICA DO SUL", align: "center", value: "vlrRcfExtCobAmericaDoSul" },
        {
          text: "DANOS MAT. DIRIGENTES ETC",
          align: "center",
          value: "danosMateriaisADirigentesSociosEmpregadosEPrepostos",
          tool: "DANOS MATERIAIS: DIRIGENTES, SÓCIOS, EMPREG. & PREPOSTOS",
        },
        { text: "VLR. DANOS MAT. DIRIGENTES ETC", align: "center", value: "vlrDmDirigenteSociosEmpregadosPrepostos" },
        {
          text: "DANOS CORP. DIRIGENTES ETC",
          align: "center",
          value: "danosCorporaisADirigentesSociosEmpregadosEPrepostos",
          tool: "DANOS CORPORAIS: DIRIGENTES, SÓCIOS, EMPREG. & PREPOSTOS",
        },
        { text: "VLR. DANOS CORP. DIRIGENTES ETC", align: "center", value: "vlrDanosCorporaisADirigentesSociosEmpregadosEPrepostos" },
        {
          text: "GU DM/DC DIRIGENTES ETC",
          align: "center",
          value: "guDmDcADirigentesSociosEmpregadosEPrepostos",
          tool: "GU DM/DC: DIRIGENTES, SÓCIOS, EMPREG. & PREPOSTOS",
        },
        { text: "VLR. GU DM/DC DIRIGENTES ETC", align: "center", value: "vlrGuDmDcADirigentesSociosEmpregadosEPrepostos" },
        {
          text: "DANOS A TERCEIROS",
          align: "center",
          value:
            "danosMateriaisCorporaisATerceirosCausadoPorReboqueSemirreboqueDesatrelado",
          tool: "DANOS MATERIAIS/CORPORAIS, CAUSADO POR REBOQUE/SEMIRREBOQUE DESATRELADO",
        },
        {
          text: "EXT. RCF VEÍC. REBOCADOS",
          align: "center",
          value: "extensaoDeCoberturaRcfAVeiculosRebocados",
          tool: "EXTENSÃO DE COBERTURA RCF A VEÍCULOS REBOCADOS",
        },
        {
          text: "VLR. EXT. RCF VEÍC. REBOCADOS",
          align: "center",
          value: "vlrExtensaoDeCoberturaRcfAVeiculosRebocados"
        },
        {
          text: "AD. CARROCERIA",
          align: "center",
          value: "coberturaAdicionalCarroceria",
          tool: "COBERTURA ADICIONAL: CARROCERIA",
        },
        { text: "DESCR. DA CARROCERIA", align: "center", value: "descrCarroceria" },
        { text: "VLR. CARROCERIA", align: "center", value: "vlrCarroceria" },
        {
          text: "AD. EQUIPAMENTOS",
          align: "center",
          value: "coberturaAdicionalEquipamentos",
          tool: "COBERTURA ADICIONAL: EQUIPAMENTOS",
        },
        { text: "DESCR. DO EQUIPAMENTO", align: "center", value: "descEquipamentos" },
        { text: "VLR. EQUIPAMENTO", align: "center", value: "vlrEquipamentos" },
        {
          text: "AD. ACESSÓRIOS",
          align: "center",
          value: "coberturaAdicionalAcessorios",
          tool: "COBERTURA ADICIONAL: ACESSÓRIOS",
        },
        { text: "DESCR. DO ACESSÓRIO", align: "center", value: "descAcessorios" },
        { text: "VLR. ACESSÓRIO", align: "center", value: "vlrAcessorios" },
        { text: "VLR. BLINDAGEM", align: "center", value: "vlrBlindagem" },
        { text: "VLR. KIT GÁS", align: "center", value: "vlrKitGas" },
        { text: "KM ASSISTÊNCIA", align: "center", value: "kmAssistencia" },
        { text: "CARROS RESERVA", align: "center", value: "carroReserva" },
        { text: "COBERTURA VIDROS", align: "center", value: "coberturaVidros" },
        { text: "TIPO DE PROPOSTA", align: "center", value: "tipoDeProposta" },
        { text: "CLASSE", align: "center", value: "classeBonus" },
        { text: "Nº APÓLICE ANTERIOR", align: "center", value: "numeroApoliceAnterior" },
        { text: "NÚMERO ANTERIOR", align: "center", value: "numeroItemAnterior" },
        { text: "TIPO DE RENOVAÇÃO", align: "center", value: "renovacaoComSinistro" },
        { text: "CIA. RENOVAÇÃO", align: "center", value: "ciaRenovacao" },
        { text: "CÓD. RENOVAÇÃO", align: "center", value: "codRenovacao" },
        { text: "DESP. SALV. CONTENÇÃO SINISTRO", value: "despesasSalvamentoContencaoSinistro" },
        { text: "VLR. DESP. SALV. CONTENÇÃO SINISTRO", value: "vlrDespesasSalvamentoContencaoSinistro" },
      ],
      snack: false,
      snackColor: "",
      snackText: "",
      dialogCobertura: false,
      dialogCalculo: false,
      regras: {
        notNull: [(v) => !!v || "Você não pode deixar este campo em branco"],
        limites: ({ min, max }) => [
          (v) =>
            +v === 0 ||
            (v >= min && v <= max) ||
            `O valor precisa ser entre ${min} e ${max}`,
        ],
      },
      pagination: {
        sortBy: "name",
      },
      selected: null,
      filtro: {
        pesquisa: {
          opened: false,
          conteudo: "",
        },
      },
      camposInfoGerais: {
        formaPagamentoList: [],
        idFormaPagamento: null,
        parcelamentoList: [],
        idParcelamento: null,
        dataPrimeiraParcela: null,
        apoliceIof: null,
        corretagem: null,
      },
      campos: {
        ufPernoiteList: [],
        tipoCoberturaList: [],
        tipoDeContratacaoList: [],
        tipoDeFranquiaList: [],
        tipoDePropostaList: [],
        ciaRenovacaoList: [],
        kmAssistenciaList: [],
        carroReservaList: [],
        descrCarroceriaList: [],
        descrEquipamentosList: [],
        descrAcessoriosList: [],
        coberturaVidrosList: [],
        diasGarantZeroKmList: [],
        vlrFranquiaDanosMateriaisList: [],
        vlrFranquiaGarantiaUnicaList: [],
        classeList: new Array(11).fill({}).map((_, index) => ({
          id: index,
          titulo: `${index}`,
        })),
        renovacaoSinistroOptions: [
          {
            id: true,
            titulo: "Com sinistro",
          },
          {
            id: false,
            titulo: "Sem Sinistro",
          },
        ],
      },
      dadosPlanilha: [],
      resultados: {
        totalAp: null,
        totalCoberturaCompensativa: null,
        totalCoberturaRcf: null,
        totalCoberturasAdicionais: null,
        totalFranquiaCoberturaAcessorios: null,
        totalFranquiaCoberturaCarroceria: null,
        totalFranquiaCoberturaCompensativa: null,
        totalFranquiaCoberturaEquipamentos: null,
        totalPremio: null,
        totalServicosAgregados: null,
        totalRestituicao: null,
      },
      limitesTaxasBasicas: {
        danosMateriais: {},
        danosCorporais: {},
        danosMoraisEEsteticos: {},
        danosMateriaisCorporaisATerceirosCausadoPorReboqueSemirreboqueDesatrelado:
          {},
        appMorte: {},
        appInvalidez: {},
        despesasMedicasHospitalaresEOdontologicas: {},
        vlrGarantiaUnica: {},
        vlrFranquiaDanosMateriais: {},
        vlrFranquiaGarantiaUnica: {},
      },
    };
  },
  computed: {
    camposDisabled() {
      return (
        (this.idStatusEndosso > statusEndossoEnum.statusEndosso.SALVO &&
          this.idStatusEndosso != statusEndossoEnum.statusEndosso.PENDENTE) ||
        this.idPropostaStatus == 7
      );
    },

    botaoVerCalculo() {
      return (
        this.idPropostaStatus == 7 ||
        (this.idStatusEndosso > statusEndossoEnum.statusEndosso.SALVO &&
          this.idStatusEndosso != statusEndossoEnum.statusEndosso.PENDENTE)
      );
    },

    ...mapState("formEndosso", [
      "id",
      "proponenteCnpj",
      "proponenteRazaoSocial",
      "quantidadeItens",
      "dateInicio",
      "dateFim",
      "valoresPremioTotal",
    ]),

    errosFiltrados() {
      return this.filtrarErros && this.numeroErros
        ? this.dadosPlanilha.filter((value) => value.erro)
        : this.dadosPlanilha;
    },
    numeroErros() {
      return Object.values(this.erroPlanilha).reduce(
        (acc, cur) => (cur ? acc + 1 : acc),
        0
      );
    },
    erroPlanilha() {
      return this.formatarErro(this.dadosPlanilha);
    },

    proximoIndice() {
      return (
        this.dadosPlanilha.reduce(
          (acc, cur) => (cur.item > acc ? cur.item : acc),
          -1
        ) + 1
      );
    },

    placaSelecionada() {
      return this.selected ? this.selected.placa : null;
    },

    modificacoesItem() {
      return this.selected && this.selected.modificacoes
        ? this.selected.modificacoes
        : null;
    },

    erros() {
      const validar = (ativo, temErro) => {
        if (!ativo) {
          return { ativo: false };
        }
        return {
          ativo: true,
          erro: temErro(),
        };
      };
      return this.dadosPlanilha.reduce(
        (acc, cur) => ({
          ...acc,
          [cur.item]: {
            danosMateriais: validar(true, () =>
              this.limiteExcedido(
                this.limitesTaxasBasicas.danosMateriais,
                cur.danosMateriais
              )
            ),
            danosCorporais: validar(true, () =>
              this.limiteExcedido(
                this.limitesTaxasBasicas.danosCorporais,
                cur.danosCorporais
              )
            ),
            danosMoraisEEsteticos: validar(true, () =>
              this.limiteExcedido(
                this.limitesTaxasBasicas.danosMoraisEEsteticos,
                cur.danosMoraisEEsteticos
              )
            ),
            appMorte: validar(true, () =>
              this.limiteExcedido(
                this.limitesTaxasBasicas.appMorte,
                cur.appMorte
              )
            ),
            appInvalidez: validar(true, () =>
              this.limiteExcedido(
                this.limitesTaxasBasicas.appInvalidez,
                cur.appInvalidez
              )
            ),
            despesasMedicasHospitalaresEOdontologicas: validar(true, () =>
              this.limiteExcedido(
                this.limitesTaxasBasicas
                  .despesasMedicasHospitalaresEOdontologicas,
                cur.despesasMedicasHospitalaresEOdontologicas
              )
            ),
            danosMateriaisCorporaisATerceirosCausadoPorReboqueSemirreboqueDesatrelado:
              validar(true, () =>
                this.limiteExcedido(
                  this.limitesTaxasBasicas
                    .danosMateriaisCorporaisATerceirosCausadoPorReboqueSemirreboqueDesatrelado,
                  cur.danosMateriaisCorporaisATerceirosCausadoPorReboqueSemirreboqueDesatrelado
                )
              ),

            //--//
            vlrGarantiaUnica: validar(cur.garantiaUnica === true, () =>
              this.limiteExcedido(
                this.limitesTaxasBasicas.vlrGarantiaUnica,
                cur.vlrGarantiaUnica
              )
            ),
            vdContratado: validar(
              this.limitesTaxasBasicas.vdContratado &&
                cur.tipoCobertura &&
                [1, 2, 4].includes(cur.tipoCobertura.id) &&
                cur.tipoDeContratacao &&
                cur.tipoDeContratacao.id === 1,
              () => {
                return (
                  cur.catVeiculo.id !== 6 &&
                  this.limiteExcedido(
                    this.limitesTaxasBasicas.vdContratado[cur.item],
                    cur.vdContratado
                  )
                );
              }
            ),
            classeBonus: {
              ativo: cur.tipoDeProposta && cur.tipoDeProposta.id !== 2,
            },

            numeroApoliceAnterior: {
              ativo: cur.tipoDeProposta && cur.tipoDeProposta.id !== 2,
            },

            numeroItemAnterior: {
              ativo: cur.tipoDeProposta && cur.tipoDeProposta.id !== 2,
            },

            renovacaoComSinistro: validar(
              cur.tipoDeProposta &&
                cur.tipoDeProposta.id === 1 &&
                cur.classeBonus > 0,
              () => typeof cur.renovacaoComSinistro !== "boolean"
            ),

            ...Object.fromEntries(
              [
                "coberturaAdicionalCarroceria",
                "coberturaAdicionalEquipamentos",
                "coberturaAdicionalAcessorios",
                "coberturaAdicionalDespesasExtras",
              ].map((key) => [
                key,
                validar(
                  cur.tipoCobertura && [1, 2, 4].includes(cur.tipoCobertura.id),
                  () => typeof cur[key] !== "boolean"
                ),
              ])
            ),
          },
        }),
        {}
      );
    },
  },

  mounted() {
    this.idApolice = this.$route.query.id;
    this.idTipoEndosso = this.$route.query.idTipoEndosso;
    this.idRascunhoEndosso = this.$route.query.idRascunhoEndosso;
    this.idPropostaStatus = this.$route.query.idPropostaStatus
      ? this.$route.query.idPropostaStatus
      : null;
    this.idStatusEndosso = this.$route.query.idStatusEndosso ? this.$route.query.idStatusEndosso : null;

    this.dadosPlanilha =
      this.$store.getters["formEndosso/cloneItemAdicionadoList"];

    this.numeroRevisao = this.$route.query.numeroRevisao;

    this.processarItensModificados();
    this.buscaOpcoes();
  },

  methods: {
    rotuloCarroReserva(catVeiculo, valor) {
      const idsNa = [1, 2, 5, 6];
      if (catVeiculo && idsNa.indexOf(catVeiculo.id) !== -1) {
        return "Não Aplicável";
      }
      return this.traduzValorObjeto(valor);
    },
    processarItensModificados() {
      const grupos = {};

      const lerValor = (item, campo) => {
        if (item.modificacoes && item.modificacoes.hasOwnProperty(campo)) {
          return item.modificacoes[campo];
        }
        return item[campo];
      };

      const aplicarEquivalencia = (campo, v1, v2) => {
        const regra = REGRAS_EQUIVALENCIA[campo];
        if (!regra) return [v1, v2];

        for (const [a, b] of regra.equivalentes) {
          if (
            (v1 === a && v2 === b) ||
            (v1 === b && v2 === a)
          ) {
            return [a, a];
          }
        }

        return [v1, v2];
      };

      const normalizarValor = (v) => {
        if (v === undefined || v === null || v === "") return null;

        if (typeof v === "object") {
          if (v.id !== undefined && v.id !== null) return String(v.id);
          if (v.titulo !== undefined && v.titulo !== null) return String(v.titulo);

          return JSON.stringify(v, Object.keys(v).sort());
        }

        if (typeof v === "number") {
          return String(v);
        }

        if (typeof v === "string") {
          return v.trim();
        }

        return String(v);
      };

      this.dadosPlanilha.forEach((item) => {
        if (!grupos[item.item]) grupos[item.item] = [];
        grupos[item.item].push(item);
      });

      Object.values(grupos).forEach((lista) => {
        if (lista.length < 2) return;

        const original = lista.find((i) => !i.isModificado) || lista[0];
        const modificado = lista.find((i) => i.isModificado) || lista[1];

        const camposModificados = [];

        CAMPOS_COMPARAVEIS.forEach((campo) => {
          let v1 = normalizarValor(lerValor(original, campo));
          let v2 = normalizarValor(lerValor(modificado, campo));

          [v1, v2] = aplicarEquivalencia(campo, v1, v2);
          if (v1 !== v2) {
            camposModificados.push(campo);
          }
        });

        original.isOriginalModificado = true;
        original.camposModificados = camposModificados;

        modificado.isModificado = true;
        modificado.camposModificados = camposModificados;
      });
    },

    getTipoEndosso(idTipoEndosso) {
      if (idTipoEndosso == 1) return "COBRANÇA";
      else if (idTipoEndosso == 2) return "EXCLUSÃO";
      else if (idTipoEndosso == 3) return "SEM MOVIMENTAÇÃO";
      else if (idTipoEndosso == 4) return " CANCELAMENTO";
      else if (idTipoEndosso == 5) return " SUBSTITUIÇÃO";
    },
    formatarErro(novosErros, listaErros = {}) {
      return {
        ...listaErros,
        ...novosErros.reduce(
          (acc, cur) => ({ ...acc, [cur.item]: cur.erro }),
          {}
        ),
      };
    },
    totaisCalculados() {
      "";
      return this.resultados || this.$store.getters["formEndosso/totais"];
    },
    formatarCnpj(cnpj) {
      if (typeof cnpj === "string" && cnpj.match(/^[A-Za-z0-9]{12}\d{2}$/)) {
        return cnpj.replace(
          /^(.{2})(.{3})(.{3})(.{4})(.{2})$/,
          "$1.$2.$3/$4-$5"
        );
      }
      return "";
    },
    formatarData(data) {
      return new Date(data).toLocaleDateString("pt-BR", {
        timeZone: "UTC",
        year: "numeric",
        month: "numeric",
        day: "numeric",
      });
    },
    formatarNumeroItem(item) {
      const numero = `000${item}`;
      return numero.slice(numero.length - 3);
    },

    formatMoney(amount) {
      return new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
      }).format(amount || 0);
    },

    buscarTitulo(entity, list) {
      if (entity !== null && entity !== undefined) {
        const campo = list.find(
          (item) => item.id === entity || item.id === entity.id
        );
        if (campo) {
          return campo.titulo;
        }
      }
      return "-";
    },

    comparador(itemLista, item) {
      if (item && item.id !== null && item.id !== undefined) {
        return item.id === itemLista.id;
      }
      return false;
    },

    colunas(item) {
      const valor = (key) => {
        if (item.modificacoes && item.modificacoes.hasOwnProperty(key)) {
          return item.modificacoes[key];
        }
        return item[key];
      };

      return [
        [this.formatarNumeroItem(valor("item")), { class: "pa-4 text-align-center", value: "item" }],
        [valor("placa"), { class: "text-align-center", value: "placa" }],
        [this.traduzValorObjeto(valor("tipoCobertura")), { class: "pa-4 text-align-center", value: "tipoCobertura" }],
        [
          this.traduzValorObjetoDinamico(valor("tipoDeContratacao"), "tipoDeContratacao") || "-",
          { class: "pa-4 text-align-center", value: "tipoDeContratacao" }
        ],
        [valor("percAjusteVmrOuVd") || "-", { class: "text-align-center", value: "percAjusteVmrOuVd" }],
        [this.traduzValorObjeto(valor("tipoDeFranquia")), { class: "text-align-center", value: "tipoDeFranquia" }],
        [valor("valorFipe") || "-", { class: "text-align-center", value: "valorFipe" }],
        [valor("vdContratado") || "-", { class: "text-align-center", value: "vdContratado" }],
        [valor("danosMateriais") || "-", { class: "text-align-center", value: "danosMateriais" }],
        [valor("danosCorporais") || "-", { class: "text-align-center", value: "danosCorporais" }],
        [valor("danosMoraisEEsteticos") || "-", { class: "text-align-center", value: "danosMoraisEEsteticos" }],
        [valor("vlrFranquiaDanosMateriais") || "-", { class: "text-align-center", value: "vlrFranquiaDanosMateriais" }],
        [this.traduzValor(valor("garantiaUnica")), { class: "text-align-center", value: "garantiaUnica" }],
        [valor("vlrGarantiaUnica") || "-", { class: "text-align-center", value: "vlrGarantiaUnica" }],
        [valor("vlrFranquiaGarantiaUnica") || "-", { class: "text-align-center", value: "vlrFranquiaGarantiaUnica" }],
        [valor("appMorte") || "-", { class: "text-align-center", value: "appMorte" }],
        [valor("appInvalidez") || "-", { class: "text-align-center", value: "appInvalidez" }],
        [valor("despesasMedicasHospitalaresEOdontologicas") || "-", { class: "text-align-center", value: "despesasMedicasHospitalaresEOdontologicas" }],
        [this.traduzValor(valor("coberturaAdicionalDespesasExtras")), { class: "text-align-center", value: "coberturaAdicionalDespesasExtras" }],
        [valor("despesasExtras") || "-", { class: "text-align-center", value: "despesasExtras" }],
        [this.traduzValor(valor("caminhaoBasculado")), { class: "text-align-center", value: "caminhaoBasculado" }],
        [this.traduzValorObjeto(valor("diasGarantZeroKm")), { class: "text-align-center", value: "diasGarantZeroKm" }],
        [this.traduzValor(valor("garantiaCompreensivaParaTumultos")), { class: "text-align-center", value: "garantiaCompreensivaParaTumultos" }],
        [this.traduzValor(valor("extCobAmericaDoSul")), { class: "text-align-center", value: "extCobAmericaDoSul" }],
        [this.traduzValor(valor("rcfExtCobAmericaDoSul")), { class: "text-align-center", value: "rcfExtCobAmericaDoSul" }],
        [valor("vlrRcfExtCobAmericaDoSul") || "-", { class: "text-align-center", value: "vlrRcfExtCobAmericaDoSul" }],
        [this.traduzValor(valor("danosMateriaisADirigentesSociosEmpregadosEPrepostos")), { class: "text-align-center", value: "danosMateriaisADirigentesSociosEmpregadosEPrepostos" }],
        [valor("vlrDmDirigenteSociosEmpregadosPrepostos") || "-", { class: "text-align-center", value: "vlrDmDirigenteSociosEmpregadosPrepostos" }],
        [this.traduzValor(valor("danosCorporaisADirigentesSociosEmpregadosEPrepostos")), { class: "text-align-center", value: "danosCorporaisADirigentesSociosEmpregadosEPrepostos" }],
        [valor("vlrDanosCorporaisADirigentesSociosEmpregadosEPrepostos") || "-", { class: "text-align-center", value: "vlrDanosCorporaisADirigentesSociosEmpregadosEPrepostos" }],
        [this.traduzValor(valor("guDmDcADirigentesSociosEmpregadosEPrepostos")), { class: "text-align-center", value: "guDmDcADirigentesSociosEmpregadosEPrepostos" }],
        [valor("vlrGuDmDcADirigentesSociosEmpregadosEPrepostos") || "-", { class: "text-align-center", value: "vlrGuDmDcADirigentesSociosEmpregadosEPrepostos" }],
        [this.traduzValor(valor("danosMateriaisCorporaisATerceirosCausadoPorReboqueSemirreboqueDesatrelado")), { class: "text-align-center", value: "danosMateriaisCorporaisATerceirosCausadoPorReboqueSemirreboqueDesatrelado" }],
        [this.traduzValor(valor("extensaoDeCoberturaRcfAVeiculosRebocados")), { class: "text-align-center", value: "extensaoDeCoberturaRcfAVeiculosRebocados" }],
        [valor("vlrExtensaoDeCoberturaRcfAVeiculosRebocados") || "-", { class: "text-align-center", value: "vlrExtensaoDeCoberturaRcfAVeiculosRebocados" }],
        [this.traduzValor(valor("coberturaAdicionalCarroceria")), { class: "text-align-center", value: "coberturaAdicionalCarroceria" }],
        [this.traduzValorObjeto(valor("descrCarroceria")), { class: "text-align-center", value: "descrCarroceria" }],
        [valor("vlrCarroceria") || "-", { class: "text-align-center", value: "vlrCarroceria" }],
        [this.traduzValor(valor("coberturaAdicionalEquipamentos")), { class: "text-align-center", value: "coberturaAdicionalEquipamentos" }],
        [this.traduzValorObjeto(valor("descrEquipamentos")), { class: "text-align-center", value: "descrEquipamentos" }],
        [valor("vlrEquipamentos") || "-", { class: "text-align-center", value: "vlrEquipamentos" }],
        [this.traduzValor(valor("coberturaAdicionalAcessorios")), { class: "text-align-center", value: "coberturaAdicionalAcessorios" }],
        [this.traduzValorObjeto(valor("descrAcessorios")), { class: "text-align-center", value: "descrAcessorios" }],
        [valor("vlrAcessorios") || "-", { class: "text-align-center", value: "vlrAcessorios" }],
        [valor("vlrBlindagem") || "-", { class: "text-align-center", value: "vlrBlindagem" }],
        [valor("vlrKitGas") || "-", { class: "text-align-center", value: "vlrKitGas" }],
        [this.traduzValorObjeto(valor("kmAssistencia")), { class: "text-align-center", value: "kmAssistencia" }],
        [this.rotuloCarroReserva(valor("catVeiculo"), valor("carroReserva")), { class: "text-align-center", value: "carroReserva" }],
        [this.rotuloVidros(valor("catVeiculo"), valor("coberturaVidros")), { class: "text-align-center", value: "coberturaVidros" }],
        [this.traduzValorObjeto(valor("tipoDeProposta")), { class: "text-align-center", value: "tipoDeProposta" }],
        [this.traduzValorObjeto(valor("classeBonus")), { class: "text-align-center", value: "classeBonus" }],
        [valor("numeroApoliceAnterior") || "-", { class: "text-align-center", value: "numeroApoliceAnterior" }],
        [valor("numeroItemAnterior") || "-", { class: "text-align-center", value: "numeroItemAnterior" }],
        [this.traduzValorSinistro(valor("renovacaoComSinistro")), { class: "text-align-center", value: "renovacaoComSinistro" }],
        [this.traduzValorObjeto(valor("ciaRenovacao")), { class: "text-align-center", value: "ciaRenovacao" }],
        [valor("codRenovacao") || "-", { class: "text-align-center", value: "codRenovacao" }],
        [this.traduzValor(valor("despesasSalvamentoContencaoSinistro")) || "-", { class: "text-align-center", value: "despesasSalvamentoContencaoSinistro" }],
        [valor("vlrDespesasSalvamentoContencaoSinistro") || "-", { class: "text-align-center", value: "vlrDespesasSalvamentoContencaoSinistro" }],
      ];
    },
    filtroFunctions: function () {
      const self = this;
      return {
        abrirFiltroPesquisa: function () {
          self.filtro.pesquisa.opened = true;
        },
        fecharFiltroPesquisa: function () {
          if (
            !self.filtro.pesquisa.conteudo ||
            self.filtro.pesquisa.conteudo == ""
          ) {
            self.filtro.pesquisa.opened = false;
          }
        },
      };
    },

    traduzValor(value) {
      if (value === true) {
        return (value = "Sim");
      } else {
        return (value = "Não");
      }
    },

    traduzValorSinistro(value) {
      if (value === true) {
        return (value = "Com Sinistro");
      } else {
        return (value = "Sem Sinistro");
      }
    },

    rotuloVidros(catVeiculo, coberturaVidrosValor) {
      if (catVeiculo && catVeiculo.id === 6) {
        return "Não Aplicável";
      }
      return this.traduzValorObjeto(coberturaVidrosValor);
    },

    traduzValorObjeto(value) {
      if (value) {
        return value.titulo;
      } else {
        return '-';
      }
    },

    traduzValorObjetoDinamico(valor, campo) {
      if (valor === undefined || valor === null) return null;

      if (typeof valor === 'object' && valor.titulo) {
        return valor.titulo;
      }

      const listaKey = MAPA_LISTAS_OBJETO[campo];
      if (listaKey && this.campos[listaKey]) {
        const encontrado = this.campos[listaKey].find(
          (op) => String(op.id) === String(valor)
        );
        return encontrado ? encontrado.titulo : valor;
      }

      return valor;
    },

    adicionarModificacao(itemModificado) {
      if (itemModificado) {
        const buscaEditado = this.dadosPlanilha.find(
          (e) => itemModificado.item === e.item
        );
        if (buscaEditado) {
          buscaEditado.modificacoes = itemModificado;
        }
      }
    },

    validaColunas() {
      return Object.values(this.erros).every((item) =>
        Object.values(item).every((subItem) => subItem.erro !== true)
      );
    },

    buscaOpcoes() {
      axios
        .get(`${process.env.URL_PLANILHAMS}/v1/buscarOpcoesCampos/`, {
          headers: {
            Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`,
          },
        })
        .then((response) => {
          [
            "tipoVeiculoList",
            "catVeiculoList",
            "ufPernoiteList",
            "usoDoVeiculoList",
            "propriedadeRegistroDoCrlvList",
            "diasGarantZeroKmList",
            "tipoCoberturaList",
            "tipoDeContratacaoList",
            "tipoDeFranquiaList",
            "tipoDePropostaList",
            "ciaRenovacaoList",
            "kmAssistenciaList",
            "carroReservaList",
            "descrCarroceriaList",
            "descrEquipamentosList",
            "descrAcessoriosList",
            "coberturaVidrosList",
            "vlrFranquiaDanosMateriaisList",
            "vlrFranquiaGarantiaUnicaList"
          ].forEach((nome) => {
            this.campos[nome] =
              response.data[nome] instanceof Array ? response.data[nome] : [];
          });
        })
        .catch((err) => {
          console.error(err);
        });
    },
    objetoModificado(){
      let itensModificado = this.$store.getters["formEndosso/requisicaoEndossoModificar"]
      if(itensModificado.idTipoEndosso === 5) {
        let listaVeiculosModificados = itensModificado.itemModificadoList

        let itensModificadoCopia = Object.assign({}, itensModificado)
        let listaVeiculosModificadosCopia = listaVeiculosModificados.map(it => Object.assign({}, it))
        itensModificadoCopia.itemModificadoList = listaVeiculosModificadosCopia
        for(var veiculoModificado of listaVeiculosModificadosCopia){
          var propriedades = Object.keys(veiculoModificado)

          for(var propriedade of propriedades){
            var value = veiculoModificado[propriedade]
            if (propriedade === 'vlrFranquiaGarantiaUnica') {

              if(value !=null && value !=undefined && value === 0){
              veiculoModificado[propriedade] = null
              }
              if(value !=null && value !=undefined && value) {
                veiculoModificado[propriedade] = value
              }
            } else if (propriedade === 'vlrFranquiaDanosMateriais') {
              if(value !=null && value !=undefined && value === 0){
              veiculoModificado[propriedade] = null
              }
              if(value !=null && value !=undefined && value) {
                veiculoModificado[propriedade] = value
              }
            } else if(propriedade === 'kmAssistencia'){
              if(value !=null && value !=undefined && value === 0) {
                veiculoModificado[propriedade] = value
              }
            }
            else {
              if(value !=null && value !=undefined && value.id === 0){
                veiculoModificado[propriedade] = null
              }
              if(value !=null && value !=undefined && value.id) {
                veiculoModificado[propriedade] = value.id
              }
            }
          }
        }
        var requestBody =  {
          ...itensModificadoCopia,
          listaCondicaoComercialEspecial: this.$store.getters["formEndosso/infoEndosso"].listaCondicaoComercialEspecial,
          listaCondicaoComercialEspecialModificacao: this.$store.getters["formEndosso/infoEndosso"].listaCondicaoComercialEspecialModificacao
        };

        return requestBody;
      }
      else if (itensModificado.idTipoEndosso === 1) {
        return this.$store.getters["formEndosso/requisicaoEndossoAdicionar"]
      }
      else if (itensModificado.idTipoEndosso === 3) {
        return this.$store.getters["formEndosso/requisicaoEndossoAdicionar"]
      }
    },
    solicitarCalculo() {
      if (!this.validaColunas()) {
        this.snack = true;
        this.snackColor = "error";
        this.snackText =
          "Não foi possível calcular porque há valores fora da faixa permitida. Corrija os campos em vermelho e tente novamente.";
      } else {
        this.loaderPagina = true;

        this.$store.commit("formEndosso/setItensModificados", {
          dados: this.dadosPlanilha
            .filter((e) => e.modificacoes)
            .map((e) => e.modificacoes),
        });
        axios
          .post(
            `${process.env.URL_ENDOSSOMS}/v1/calcularEndosso/${this.idApolice}`,
            this.objetoModificado(),

            {
              headers: {
                Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`,
              },
            }
          )
          .then((response) => {
            this.loaderPagina = false;
            Object.keys(this.resultados).forEach((item) => {
              this.resultados[item] = response.data[item];
            });
            this.dialogCalculo = true;
          })
          .catch((error) => {
            this.loaderPagina = false;
            this.snack = true;
            this.snackColor = "error";
            error.response.data.message
              ? (this.snackText = error.response.data.message)
              : (this.snackText = "generico");
          });
      }
    },

    voltar: function () {
      if (this.numeroRevisao) {
        this.$router.push(
          `/GridPrincipal/GridEndossoVeiculoSubstituicao?id=${this.idApolice}${
            this.idStatusEndosso ? `&idStatusEndosso=${this.idStatusEndosso}` : ''
          }&idTipoEndosso=${this.idTipoEndosso}&idPropostaStatus=${this.idPropostaStatus}`
        );
      } else if (this.idRascunhoEndosso) {
        this.$router.push(
          `/GridPrincipal/GridEndossoVeiculoSubstituicao?id=${this.idApolice}${
            this.idStatusEndosso ? `&idStatusEndosso=${this.idStatusEndosso}` : ''
          }&idTipoEndosso=${this.idTipoEndosso}&idRascunho=${this.idRascunhoEndosso}&idPropostaStatus=${this.idPropostaStatus}`
        );
      } else {
        this.$router.push(
          `/GridPrincipal/GridEndossoVeiculoSubstituicao?id=${this.idApolice}${
            this.idStatusEndosso ? `&idStatusEndosso=${this.idStatusEndosso}` : ''
          }&idTipoEndosso=${this.idTipoEndosso}&idPropostaStatus=${this.idPropostaStatus}${
            this.numeroRevisao ? `&numeroRevisao=${this.numeroRevisao}` : ''
          }`
        );
      }
    },

    limiteExcedido({ min, max }, value) {
      return +value !== 0 && (value < min || value > max);
    },
    formatarNumeroCotacao(item) {
      const numero = `000000${item}`;
      return numero.slice(numero.length - 6);
    },
  },
};
</script>

<style scoped>
  .background {
    background-color: white;
  }

  .item-primary .v-menu__activator {
    display: flex;
    justify-content: center;
    text-align: center !important;
  }

  .item-color > div > a {
    color: #757575 !important;
  }

  .errorTaxa {
    color: red !important;
    font-weight: bold;
  }

  .button-permanecer {
    background: #00456e;
    color: #fff !important;
  }

  .text-permanecer {
    font-weight: bold;
    color: #757575 !important;
  }

  .text-align-center {
    text-align: center;
  }

.faixa-modificado {
  border-left: 6px solid #e06565;
}

.coluna-modificada {
  border-left: 4px solid #e06565;
}

.linha-original-modificada {
  background-color: #b71c1c !important;
  color: #ffffff !important;
}

.linha-original-modificada * {
  color: #ffffff !important;
}
</style>




// WEBPACK FOOTER //
// src/components/pages/frota/CoberturaEndossoSubstituicao.vue